import classNames from "classnames";
import AscErrorBoundary from "../../AscErrorBoundary/AscErrorBoundary";
import AscSkillsRadarChart from "../../AscSkillsRadarChart/AscSkillsRadarChart";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscSkillGraphCard.module.scss";

export interface AscSkillGraphCardProps {
  title?: string;
  data?: {
    label: string;
    value: number;
  }[];
  className?: string;
  loading?: boolean;
}

const INITIAL_DATA = [
  {
    label: "label",
    value: 0,
  },
];

export default function AscSkillGraphCard({
  title = "Skill Graph",
  data = INITIAL_DATA,
  className,
  loading = false,
}: AscSkillGraphCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={title}
      coverImageUrl={null}
      loading={loading}
    >
      <AscErrorBoundary>
        {data?.length ? <AscSkillsRadarChart data={data} /> : null}
      </AscErrorBoundary>
    </AscGenericCard>
  );
}
